export default "__VITE_ASSET__nKRbaMtN__"